import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material";
import { ToastService } from "ng-uikit-pro-standard";
import { MetarelatedlistfieldComponent } from "../metarelatedlistfield/metarelatedlistfield.component";

@Component({
  selector: "app-metarelatedlistdrop",
  templateUrl: "./metarelatedlistdrop.component.html",
  styleUrls: ["./metarelatedlistdrop.component.scss"],
})
export class MetarelatedlistdropComponent implements OnInit {
  droppedFields: any[] = [];
  selectedLookupFields: any[] = [];
  draggedIndex: number | null = null;

  @Output() buttonDroppedEvent: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() RelatedfieldsDoneEmitter: EventEmitter<any[]> = new EventEmitter<
    any[]
  >();
  @Output() RelatedbuttonsDoneEmitter: EventEmitter<any[]> = new EventEmitter<
    any[]
  >();
  @Input() droppedLookupField = [];
  @Output() droppedLookupEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() LookupfieldDeletedEvent = new EventEmitter<any>();

  constructor(public dialog: MatDialog, private toastrService: ToastService) {}

  ngOnInit() {}

  displayedColumns: string[] = ["label", "name", "description", "createdby"];
  dataSource = new MatTableDataSource<any>([]);
  // dataSource = '';

  delete(index: any) {
    console.log("Type Deleted", index);
    const field = this.droppedLookupField[index];
    this.LookupfieldDeletedEvent.emit(field);
    this.droppedLookupField.splice(index, 1);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  onLookupDrop(event: DragEvent) {
    event.preventDefault();
    const field = event.dataTransfer.getData("application/json");
    console.log("Dragged JSON:", JSON.parse(field));

    this.buttonDroppedEvent.emit(true);

    if (field.length > 0) {
      const lookupfield = JSON.parse(field);
      console.log("Field:", lookupfield);

      if (lookupfield != null) {
        const newData = [
          {
            label: lookupfield.labelname,
            name: lookupfield.fieldname,
            description: lookupfield.description,
            createdby: lookupfield.createdby,
          },
        ];

        this.dataSource.data = newData;

        var lookupdroppedfields = {
          metaobjectid: lookupfield.id,
          label: lookupfield.label,
          metaobjectname: lookupfield.name,
          description: lookupfield.description,
          lookupfield: lookupfield.lookupfield,
          iconname: lookupfield.iconname,
          linkedobject: lookupfield.linkobject,
          followup: lookupfield.followup,
          // childrelationshipname: lookupfield.lookupfield.attributes.childrelationshipname,
          selectedLookupFields: [],
          selectedLookupButtons: [],
          selectedViewFields: [],
          selectedViewButtons: [],
        };
      }

      // if (lookupfield.id.startsWith("po9")) {
      if (lookupfield.hasOwnProperty("lookupfield")) {
        this.droppedLookupField.push(lookupdroppedfields);
        lookupfield.dropped = true;
        this.droppedLookupEvent.emit(this.droppedLookupField);

        console.log("Dropped Lookup:", this.droppedLookupField);
      } else {
        this.showWarning("Not a Lookup type, Drop not accepted");
        console.log("Not a Lookup type, Drop not accepted.");
      }
    }
  }

  generateUniqueId(): string {
    return Math.random().toString(36).substr(2, 9);
  }

  showDialog(
    metaobjectid: any,
    metaobjectname: any,
    iconname: any,
    index: any,
    linkedobject: any,
    followup: any
  ) {
    const lookupField = this.droppedLookupField[index];
    console.log("metaobjectid", metaobjectid);
    console.log("metaobjectname", metaobjectname);
    console.log("iconname", iconname);
    console.log("index", index);
    console.log(
      "showDialog received:",
      metaobjectid,
      metaobjectname,
      iconname,
      index,
      linkedobject
    );
    const dialogRef = this.dialog.open(MetarelatedlistfieldComponent, {
      height: "60%",
      width: "60%",
      disableClose: true,
      data: {
        metaObjectId: metaobjectid,
        metaObjectname: metaobjectname,
        iconName: iconname,
        index: index,
        linkedobject: linkedobject,
        followup: followup,
        retrievedData: this.droppedLookupField,
      },
    });
    console.log(this.droppedLookupField);

    console.log("linkedobject", lookupField.linkedobject);
    console.log("followup", lookupField.followup);

    dialogRef.afterClosed().subscribe((results) => {
      console.log("The dialog was closed");
      console.log("metaobjectid", metaobjectid);

      if (results && results.fieldsDone) {
        console.log("updateFieldProperties", results);
        console.log("updateFieldProperties", results.fieldsDone);

        const lookupField = this.droppedLookupField.find(
          (field) => field.metaobjectid === metaobjectid
        );
        if (lookupField) {
          lookupField.selectedLookupFields = results.fieldsDone;
          lookupField.selectedLookupButtons = results.ButtonsDone;
          lookupField.selectedViewFields = results.ViewfieldsDone;
          lookupField.selectedViewButtons = results.ViewButtonsDone;
          lookupField.location = results.location;
          lookupField.viewtype = results.viewtype;
          lookupField.sortfield = results.sortfield;
          lookupField.sortorder = results.sortorder;
          lookupField.uploadtype = results.uploadtype;
          lookupField.enableversioning = results.enableversioning;
          lookupField.linkedobject = results.linkedobject;
          lookupField.contrareferencefields = results.contrareferencefields;
          lookupField.contrafield = results.contrafield;
          lookupField.relatedgroupname = results.relatedgroupname;
          lookupField.iconname = results.iconname;
          lookupField.fieldname = results.fieldname;
          lookupField.referencefieldname = results.referencefieldname;
          lookupField.fieldid = results.fieldid;
          lookupField.childrelationshipname = results.childrelationshipname;
          lookupField.relatedlistlabel = results.relatedlistlabel;
          lookupField.attributes = results.attributes || {};
          lookupField.relatedFilters = results.relatedFilters || [];
        }

        this.RelatedfieldsDoneEmitter.emit(this.droppedLookupField);
        console.log("droppedLookupField", this.droppedLookupField);
      } else {
        // Reset selectedLookupFields if the dialog was closed without saving.
        // const lookupField = this.droppedLookupField.find(
        //   (field) => field.metaobjectid === metaobjectid
        // );
        // if (lookupField) {
        //   lookupField.selectedLookupFields = [];
        //   lookupField.selectedLookupButtons = [];
        //   lookupField.selectedViewFields = [];
        //   lookupField.selectedViewButtons = [];
        // }
      }
    });
  }

  onFieldDropchange(event: DragEvent, newIndex: number) {
    event.preventDefault();

    console.log("Current index", this.draggedIndex);
    console.log("Dropped index", newIndex);
    if (this.draggedIndex !== null && this.draggedIndex !== newIndex) {
      // Swap the positions of the dragged item and the dropped item
      const tempField = this.droppedLookupField[this.draggedIndex];
      this.droppedLookupField[this.draggedIndex] =
        this.droppedLookupField[newIndex];
      this.droppedLookupField[newIndex] = tempField;

      this.droppedLookupField.forEach((item, index) => {
        item.index = index;
      });

      console.log("Dropped data reordered:", this.droppedLookupField);
    }

    //Reset index
    this.draggedIndex = null;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDragStart(event: DragEvent, index: number) {
    this.draggedIndex = index;

    console.log(index);
  }
}
